import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=96faa0a6&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Products.vue?vue&type=style&index=1&id=96faa0a6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96faa0a6",
  null
  
)

export default component.exports